import { ArrowLeft, Ghost } from 'lucide-react';
import { Link } from 'react-router-dom';
import { buttonStyles } from '../components/Button';
import { LogoLink } from '../components/Logo';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <header className="mx-auto flex h-20 w-full max-w-7xl items-center px-4 sm:px-6">
        <LogoLink />
      </header>
      <main className="flex flex-1 items-center justify-center px-4 pb-20">
        <div className="text-center">
          <div className="mx-auto mb-5 flex size-14 items-center justify-center rounded-2xl border border-white/[0.08] bg-white/[0.03]">
            <Ghost className="size-6 text-zinc-500" />
          </div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-600">404</p>
          <h1 className="mt-3 text-2xl font-semibold tracking-tight text-white">Страница не найдена</h1>
          <p className="mt-2 text-[13px] text-zinc-500">Возможно, ссылка устарела или комната удалена.</p>
          <Link to="/dashboard" className={buttonStyles('primary', 'md', 'mt-6')}>
            <ArrowLeft className="size-4" />
            В кабинет
          </Link>
        </div>
      </main>
    </div>
  );
}
